const youtubeVideoIdPattern = /^[A-Za-z0-9_-]{11}$/;

const youtubeHosts = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "music.youtube.com",
]);

const youtubeNoCookieHosts = new Set([
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
]);

const youtubeShortHosts = new Set(["youtu.be", "www.youtu.be"]);

const getUrl = ({ value }: { value: string }): URL | null => {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  const valueWithProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmedValue)
    ? trimmedValue
    : `https://${trimmedValue}`;

  try {
    return new URL(valueWithProtocol);
  } catch {
    return null;
  }
};

export const getYouTubeVideoId = ({
  value,
}: {
  value: string;
}): string | null => {
  const url = getUrl({ value });
  if (
    !url ||
    (url.protocol !== "http:" && url.protocol !== "https:") ||
    url.username ||
    url.password ||
    url.port
  ) {
    return null;
  }

  const pathParts = url.pathname.split("/").filter(Boolean);
  let videoId: string | null = null;

  if (youtubeShortHosts.has(url.hostname)) {
    videoId = pathParts.length === 1 ? pathParts[0] : null;
  } else if (youtubeNoCookieHosts.has(url.hostname)) {
    videoId =
      pathParts.length === 2 && pathParts[0] === "embed"
        ? pathParts[1]
        : null;
  } else if (youtubeHosts.has(url.hostname)) {
    if (
      (url.pathname === "/watch" || url.pathname === "/watch/") &&
      pathParts.length === 1
    ) {
      videoId = url.searchParams.get("v");
    } else if (
      pathParts.length === 2 &&
      ["embed", "v", "shorts", "live"].includes(pathParts[0])
    ) {
      videoId = pathParts[1];
    }
  }

  return videoId && youtubeVideoIdPattern.test(videoId) ? videoId : null;
};

export const normalizeYouTubeVideoUrl = ({
  value,
}: {
  value: string;
}): string | null => {
  const videoId = getYouTubeVideoId({ value });
  return videoId ? `https://www.youtube.com/watch?v=${videoId}` : null;
};

export const getYouTubeEmbedUrl = ({
  value,
}: {
  value: string;
}): string | null => {
  const videoId = getYouTubeVideoId({ value });
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};
